import type { RequestOptions, ApiResponse } from "@/shared/types/request";
import type { Entry } from "@/shared/types/entries";

export type ActionDeps = {
	makeApiRequest: (opts: RequestOptions) => Promise<ApiResponse>;
	updateEntries: (updater: (prev: Entry[]) => Entry[]) => () => void;
	refreshRecords: () => Promise<void>;
};

export function plural(n: number) {
	return n === 1 ? "entry" : "entries";
}

export async function apiCall(
	deps: ActionDeps,
	opts: RequestOptions,
): Promise<void> {
	const resp = await deps.makeApiRequest(opts);
	if (resp.status === "ERROR") {
		throw new Error(resp.error || "Request failed");
	}
}
